
export default function SingleProductPulse({}) {
    return (
        <div className="border border-olaf-green-400 shadow p-4 max-w-sm w-full mx-auto">
            <div className="animate-pulse flex space-x-4 relative flex-col">
                <div className="bg-olaf-green-400 h-[350px] w-full"></div>
                <div className=" space-y-2 py-4 ml-0">
                    <div className="h-2 bg-olaf-green-400 rounded"></div>
                    <div className="space-y-3">
                        <div className="grid grid-cols-3 gap-4">
                            <div className="h-2 bg-olaf-green-400 rounded"></div>
                            <div className="h-2 bg-olaf-green-400 rounded"></div>
                        </div>
                        <div className="h-2 bg-olaf-green-400 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
